export default __webpack_public_path__ + "static/media/nottodolist.04ca7c88.PNG";